import { ValidacaoUtil } from './../validacao.util';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { empty } from 'rxjs/Observer';
import { isEmpty } from 'rxjs/operator/isEmpty';
import { CODIGO_CENTRUS, DESCRICAO_CARD } from '../../../../app.constants';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { ItemMenu } from '../../dominios/item-menu';
import { CardModel } from '../../models/card.model';
import { PaginaCardsModel } from '../../models/pagina-cards.model';
import { DocumentosService } from '../../services/documentos.service';
import { FilterDefaultService } from '../../services/filter-default.service';
import { ValidarPermissaoFuncionalidadeService } from '../../services/validar-permissao-funcionalidades.service';
import { StorafeUtil } from '../storasge.util';
import { UtilService } from '../util.service';

@Injectable()
export class FuncoesCardMenu {

  paginaCards: PaginaCardsModel[] = [];

  param = '/home';

  matricula = '0000000'

  itemMenu$: Observable<ItemMenu[]>;

  constructor(
    private documentosService: DocumentosService,
    private authInterceptor: AuthInterceptor,
    private validarPermissaoFuncionalidadeService: ValidarPermissaoFuncionalidadeService,
    private filterDefaultService: FilterDefaultService,
    private router: Router,
    private store: Store<ItemMenu>
  ) {
    this.itemMenu$ = store.pipe(select('itemMenuLista'));
  }

  async listarItensMenu(): Promise<PaginaCardsModel[]> {

    return new Promise<PaginaCardsModel[]>((resolve, reject) => {

      const itemMenuNome = (StorafeUtil.recuperarSessionStorage(DESCRICAO_CARD))
        ? (JSON.parse(StorafeUtil.recuperarSessionStorage(DESCRICAO_CARD)))
        : null;

      // this.itemMenu$.subscribe(async (arg) => this.paginaCards = await this.getCardsMenu(itemMenuNome, arg))
      this.validarPermissaoFuncionalidadeService.getItensMenuLateral()
        .then(itensMenu => {
          this.getCardsMenu(itemMenuNome, itensMenu)
            .then(res => resolve(res))
        })
    })

  }


  async getCardsMenu(itemMenuNome, itensMenu): Promise<PaginaCardsModel[]> {
    return new Promise<PaginaCardsModel[]>(async (resolve, reject) => {

      this._buscarItemMenuPai(itemMenuNome, itensMenu)
        .then(itemMenuPai => {
          this._buscarFilhos(itemMenuPai, itensMenu)
            .then(itemmenuFilhos => {
              this._buscarFilhosDosFilhos(itemmenuFilhos, itensMenu)
                .then(async itemmenuFilhosDosFilhos => {
                  const agruparItensMenu = await this._agruparItensMenuSemFilhos(itemMenuPai.dsItemMenu, itemmenuFilhos, itemmenuFilhosDosFilhos)
                  resolve(agruparItensMenu);
                })
            })
        })
    })
  }

  public carregarItensCardsPaginaInial(): Promise<PaginaCardsModel[]> {
    return new Promise((resolve, reject) => {
      const paginaCards = new PaginaCardsModel();
      this.paginaCards = [];
      // this.itemMenu$.subscribe(async (arg) => this.paginaCards = await this.getCardsMenu(itemMenuNome, arg))
      this.validarPermissaoFuncionalidadeService.getItemMenuPaiIdSistema()
        .then(async res => {
          res.forEach(element => {
            if (element.sgItemMenu.toLowerCase().indexOf('início') === -1) {
              paginaCards.titulo = 'Início';
              const imagem = this._recuperarImagem(element.imagem);
              paginaCards.cardList.push(new CardModel(element.dsUrl, element.sgItemMenu, element.dsItemMenu, imagem, element.tpTela, element.irNumeracao));

            }
          })

          if (paginaCards.cardList.length > 0) {
            this.paginaCards.push(paginaCards);

            this.paginaCards[0].cardList.sort(function (a, b) {
              return a.numeroOrdem < b.numeroOrdem ? -1 : a.numeroOrdem > b.numeroOrdem ? 1 : 0;
            });
          }

          resolve(this.paginaCards);

        })

    })
  }

  private _buscarItemMenuPai(itemMenuNome, itensMenu): Promise<ItemMenu> {
    return new Promise((resolve, reject) => {
      itensMenu = itensMenu.find(function (elem) {
        return (elem.sgItemMenu.toLowerCase() === itemMenuNome.toLowerCase())
      });
      resolve(itensMenu);
    })
  }

  private _buscarFilhos(itemMenuPai, itensMenu): Promise<ItemMenu[]> {
    return new Promise((resolve, reject) => {
      itensMenu = itensMenu.filter(function (elem) {
        return (elem.itemMenuPai && itemMenuPai) && (elem.itemMenuPai.idItemMenu === itemMenuPai.idItemMenu);
      })
      resolve(itensMenu);
    })
  }

  private _buscarFilhosDosFilhos(itemmenuFilhos, itensMenu): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const filhoDosFilhos = [];
      itemmenuFilhos.filter(function (item) {
        return itensMenu.map(function (elem) {
          return (elem.itemMenuPai) && ((elem.itemMenuPai.idItemMenu === item.idItemMenu) && (filhoDosFilhos.push({ pai: item.idItemMenu, filhos: elem })));
        })
      })
      resolve(filhoDosFilhos);
    })
  }


  private _agruparItensMenuSemFilhos(itemMenuNome, itemmenuFilhos, itemmenuFilhosDosFilhos): Promise<PaginaCardsModel[]> {
    return new Promise((resolve, reject) => {
      const paginaCards = new PaginaCardsModel();
      let paginaCardsAgrupados: PaginaCardsModel[] = [];

      itemmenuFilhos.forEach(async element => {
        const encontrado = itemmenuFilhosDosFilhos.find(index => element.idItemMenu === index.pai);

        if (!encontrado || encontrado.pai === 253) {
          paginaCards.titulo = itemMenuNome;
          const imagem = this._recuperarImagem(element.imagem);
          paginaCards.cardList.push(new CardModel(element['dsUrl'], element['sgItemMenu'], element['dsItemMenu'], imagem, element['tpTela'], null));
          paginaCardsAgrupados = [...[paginaCards]];
        } else {
          const agruparItensMenuComFilhos = await this._agruparItensMenuComFilhos(element, itemmenuFilhosDosFilhos)
          paginaCardsAgrupados.push(agruparItensMenuComFilhos);
        }
      });

      resolve(paginaCardsAgrupados);
    })
  }

  private _agruparItensMenuComFilhos(element, itemmenuFilhosDosFilhos): Promise<PaginaCardsModel> {
    return new Promise((resolve, reject) => {
      const paginaCards = new PaginaCardsModel();
      itemmenuFilhosDosFilhos.filter(index => {
        if (element.idItemMenu === index['pai']) {
          paginaCards.titulo = element.dsItemMenu;
          const imagem = this._recuperarImagem(index.filhos.imagem);
          paginaCards.cardList.push(new CardModel(index['filhos']['dsUrl'], index['filhos']['sgItemMenu'], index['filhos']['dsItemMenu'], imagem, index['filhos']['tpTela'], null));
        }
      });
      if (paginaCards.cardList.length > 0) { resolve(paginaCards) };
    })
  }


  direcionar(dadosCards: CardModel): void {

    try {
      switch (dadosCards.tipoCaminho) {
        case 0:
          this._direcionarLinkExterno(dadosCards);
          break;
        case 1:
          this._direcionarLinkInterno(dadosCards.caminho);
          break;
        case 2:
          this._deirecionarDocumento(dadosCards.caminho);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);

    }
  }


  private _direcionarLinkInterno(caminho): void {
    this.router.navigate([caminho], { skipLocationChange: true });
  }

  // , { replaceUrl: true })

  async _direcionarLinkExterno(dadosCards) {

    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
    const cdCentrus = (recuperandoObjeto) ? recuperandoObjeto : this.authInterceptor.getJwtCdCentrus();

    // console.log(dadosCards);


    if (dadosCards.sigla.toLowerCase() === 'aec'.toLowerCase()) {
      window
        .open(dadosCards.caminho)
    };

    if (dadosCards.sigla.toLowerCase() === 'mv2020'.toLowerCase()) {
      window
        .open(dadosCards.caminho)
    };

    if (dadosCards.sigla.toLowerCase() === 'webmail'.toLowerCase()) {
      window
        .open(dadosCards.caminho)
    };

    if (dadosCards.sigla.toLowerCase() === 'oe2018'.toLowerCase()) {
      window
        .open(dadosCards.caminho)
    };

    if (dadosCards.sigla.toLowerCase() === 'atualizar_cad'.toLowerCase()) {
      window
        .open(`${dadosCards.caminho}${cdCentrus}`)
    };

    if (dadosCards.sigla.toLowerCase() === 'pcdipec'.toLowerCase()) {
      this._direcionarParaSistemaPCD(dadosCards, cdCentrus)
    };

    if (dadosCards.sigla.toLowerCase() === 'W_EMP'.toLowerCase()) { this._direcionarParaSistemaEmprestimo(dadosCards, cdCentrus) };

    if (dadosCards.sigla.toLowerCase() === 'W_VOTO'.toLowerCase()) { this._direcionarParaSistemaEleicao(dadosCards, cdCentrus) };

    if (dadosCards.sigla.toLowerCase() === 'W_VOTOMA'.toLowerCase()) { this._direcionarParaSistemaEleicao(dadosCards, cdCentrus) };

    if (dadosCards.sigla.toLowerCase() === 'W_MVOTO'.toLowerCase()) { this._direcionarParaSistemaEleicao(dadosCards, cdCentrus) };

    // &ipusuario=${ipUsuario}
  }

  private async _direcionarParaSistemaPCD(dadosCards, cdCentrus): Promise<void> {
    const matriculaBacen = await this.filterDefaultService.getConfirmaPlanoPatrocinadoraBacenPCD(Number(cdCentrus));

    const matriculaCentrus = await this.filterDefaultService.getConfirmaPlanoPatrocinadoraCentrusPCD(Number(cdCentrus));

    UtilService.CAMINHO_ACESSO_SISTEMA_PCD_CONSULTAR_DADOS = dadosCards.caminho;

    (matriculaBacen['matriculaBacen'] !== 'null' && matriculaCentrus['matriculaCentrus'] !== 'null')
      ? (this.router.navigate(['/confimerMatricula', matriculaBacen['matriculaBacen'], matriculaCentrus['matriculaCentrus']], { skipLocationChange: true }))
      : ((matriculaCentrus['matriculaCentrus'] !== 'null')
        ? (window
          .open(`${dadosCards.caminho}&cdcentrus=${cdCentrus}&matricula_dv=${matriculaCentrus['matriculaCentrus']}&origem_func=${1}`))
        : (window
          .open(`${dadosCards.caminho}&cdcentrus=${cdCentrus}&matricula_dv=${matriculaBacen['matriculaBacen']}&origem_func=${3}`))
      );
  }

  private async _direcionarParaSistemaEleicao(dadosCards, cdCentrus): Promise<void> {
    const findByCentrusPBConfirmaLista = await this.filterDefaultService.findByCentrusPBConfirmaLista(Number(cdCentrus));
    const findByCentrusPB = await this.filterDefaultService.findByCentrusPB(Number(cdCentrus));
    const findByCentrusPC = await this.filterDefaultService.findByCentrusPC(Number(cdCentrus));

    const matricula = await this._carregarMatriculaPatrocinadora(findByCentrusPB, findByCentrusPC);


    if (findByCentrusPBConfirmaLista ||
      (findByCentrusPC && findByCentrusPB)) {
      this._deirecionarPageEscolherMatriculaEmprestimo('confimerMatriculaEleicao', cdCentrus);
    } else {
      window
        .open(`${dadosCards.caminho}&cdcentrus=${cdCentrus}&matricula=${matricula}`)
    }
  }

  private async _direcionarParaSistemaEmprestimo(dadosCards, cdCentrus): Promise<void> {

    const matriculasLista = Object.values(await this.filterDefaultService.findBysMatriculasBacen(Number(cdCentrus)));

    if( matriculasLista.length > 1){
        console.log(matriculasLista)
        this._deirecionarPageEscolherMatriculaEmprestimo('confimerMatriculaEmprestimo', cdCentrus);
    } else {
    const findByCentrusPBConfirmaLista = await this.filterDefaultService.findByCentrusPBConfirmaLista(Number(cdCentrus));
    const findByCentrusPB = await this.filterDefaultService.findByCentrusPB(Number(cdCentrus));
    const findByCentrusPC = await this.filterDefaultService.findByCentrusPC(Number(cdCentrus));

    const matricula = await this._carregarMatriculaPatrocinadora(findByCentrusPB, findByCentrusPC);


    if (findByCentrusPBConfirmaLista ||
      (findByCentrusPC && findByCentrusPB)) {
      this._deirecionarPageEscolherMatriculaEmprestimo('confimerMatriculaEmprestimo', cdCentrus);
    } else {
      window
        .open(`${dadosCards.caminho}&cdcentrus=${cdCentrus}&matricula=${matricula}`)
    }
   }
  }


  private async _carregarMatriculaPatrocinadora(varPatrocinadoraBacen, varPatrocinadoraCentrus): Promise<string> {

    if (varPatrocinadoraBacen != null) {
     const numeroOrdem = varPatrocinadoraBacen['id']['nrOrdemMatr'];
     let numeroMatricula = varPatrocinadoraBacen['numeroMatriculaBacenFormatado'];
     if (ValidacaoUtil.isNullOrEmpty(numeroMatricula)) {
      numeroMatricula = varPatrocinadoraBacen['id']['nrMatr'];
     }
     return this.verificaNumeroOrdem(numeroOrdem, numeroMatricula);
    }else {
      if (varPatrocinadoraCentrus != null) {
        const numeroOrdem = varPatrocinadoraCentrus['id']['nrOrdemMatr'];
        const numeroMatricula = varPatrocinadoraCentrus['id']['nrMatr'];
        return this.verificaNumeroOrdem(numeroOrdem, numeroMatricula);
       }
    }

    return null;
  }

  private verificaNumeroOrdem(numeroOrdem, numeroMatricula)  {
    if (numeroOrdem === 0) {
      return numeroMatricula;
    }else {
      return this.getMatriculaFormatada(numeroOrdem, numeroMatricula);
    }
  }

  private getMatriculaFormatada(numeroOrdem, numeroMatricula){
       // tslint:disable-next-line:no-construct
       const str1 = new String(numeroMatricula);
       // tslint:disable-next-line:no-construct
     const str2 = new String(numeroOrdem);
      const str3 = str2.concat(str1.toString());
      return str3;
  }

  private _deirecionarDocumento(caminho): void {
    this.documentosService.downloandDocument('pdf', caminho);
  }

  private _deirecionarPageEscolherMatriculaEmprestimo(caminho, cdCentrus): void {
    this.router.navigate([caminho, cdCentrus], { skipLocationChange: true })
  }


  public _recuperarImagem(imagem): string {
    return (imagem) ?
      (`data:${imagem.tpImagem};base64,${imagem.ctImagem}`)
      : ('../../../../../assets/layout/images/question.png')
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/funcaoes-card-menu/funcoes-card-menu.ts